/* @flow */

import { invalidateTags } from 'src/shared/app/base/api/actions/apiActions';
import { ENTITIES_TYPE } from 'src/shared/app/base/api/apiConstant';
import { getQueryTag } from 'src/shared/app/base/api/utils/endpointUtils';
import * as types from './entityActionTypes';

export function getAllTagfromEntities(entities: Object) {
  const entitiesNames = Object.keys(entities);
  const tagsList = entitiesNames
    .flatMap(
      (entity) =>
        ENTITIES_TYPE[entity] &&
        Object.keys(entities[entity]).flatMap((id) =>
          getQueryTag(ENTITIES_TYPE[entity], id),
        ),
    )
    .filter(Boolean);
  return tagsList;
}

export function patchEntities(entities: Object) {
  return (dispatch: any) => {
    dispatch(invalidateTags(getAllTagfromEntities(entities)));
    dispatch({
      type: types.PATCH_ENTITIES,
      entities,
    });
  };
}
